module.exports = __webpack_public_path__ + "static/media/report-nurse-icon.cf0457b2.svg";